<template>
  <div data-component-group="sponsor-dialog" data-component="add-new">
    <dialog-add
      :title="$t('logo_sponsorship')"
      icon="bolt"
      is-fullscreen
      :is-on="true"
      :on-close="onCancel"
    >
      <template v-slot:content>
        <forms-sponsorships-add-new
          ref="addNewSponsorshipForm"
          class="elevation-1"
        />
      </template>
    </dialog-add>
  </div>
</template>

<script>
export default {
  methods: {
    onCancel() {
      this.$refs.addNewSponsorshipForm.cancel();
    },
  },
};
</script>
